<div class="mt-4">

    <div class="flex justify-end items-center">
        <button mat-icon-button matSuffix (click)="importExcel()">
            <mat-icon>unarchive
            </mat-icon>
        </button>
    </div>
    <div class="mt-1">
        <mat-divider></mat-divider>
    </div>
    <div class="flex flex-row justify-end items-end gap-5 mt-4 mr-2">

        <button mat-flat-button class="btn-tg" *ngIf="editIndex === null" (click)="addItemToList()">
            Adicionar
        </button>

    </div>
    <div class="mt-4"></div>
    @if(!loading) {

    <div class="mt-4">
        @if (passengers.length > 0) {
        <div>
            <table-list-passangers [dataSource]="itemsList" [columns]="columns" (editItem)="editItem($event)"
                (deleteItem)="deleteItem($event)" />
        </div>
        }@else{
        <div class="text-center py-8 text-gray-500">
            Nenhum passageiro cadastrado
        </div>
        }
    </div>
    }@else{
    <div class="flex justify-center items-center">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    }

</div>